import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import SearchResultsList from './components/SearchResultsList';
import LinkView from './components/LinkView';
import AppMenu from './components/AppMenu';
import AutocompleteInput from './components/AutocompleteInput';
import EventBus from 'eventbusjs';
import GoogleAnalytics from './components/GoogleAnalytics';
import config from './config';
import MatomoVeftalning from './components/MatomoVeftalning';
import './style.css';

class App extends Component {
	constructor(props) {
		super(props);

		window.eventBus = EventBus;

		//window.app = this;

		this.inputChangeHandler = this.inputChangeHandler.bind(this);
		this.searchButtonClickHandler = this.searchButtonClickHandler.bind(this);
		this.searchKeyDownHandler = this.searchKeyDownHandler.bind(this);
		this.menuButtonClickHandler = this.menuButtonClickHandler.bind(this);
		this.inputFocusHandler = this.inputFocusHandler.bind(this);
		this.languageChangedHandler = this.languageChangedHandler.bind(this);

		this.state = {
			searchString: '',
			inputFocus: false,
			menuOpen: false
		};
	}

	languageChangedHandler() {
		this.forceUpdate();
	}

	componentDidMount() {
		// Hér hlustum við eftir breytingu á route
		this.refs.router.history.listen(function(event) {
			this.setState({
				routePath: event.pathname,
				menuOpen: false
			});

			window.scrollTo(0, 0)
		}.bind(this));

		document.addEventListener('mousedown', function(event) {
			if (!this.state.menuOpen) {
				return;
			}

			if (this.refs.menuButton.contains(event.target)) {
				event.stopPropagation();

				return;
			}

			if (this.refs.appMenu && this.refs.appMenu.refs.menuContent && !this.refs.appMenu.refs.menuContent.contains(event.target)) {
				this.setState({
					menuOpen: false
				})
			}
		}.bind(this));

		window.eventBus.addEventListener('Lang.languageChanged', this.languageChangedHandler);

		setTimeout(function() {
			this.refs.searchInput.refs.inputField.focus();
		}.bind(this), 100);
	}

	inputFocusHandler() {
		this.refs.searchInput.refs.inputField.select();
	}

	menuButtonClickHandler(event) {
		if (!this.state.menuOpen) {
			this.refs.appMenu.refs.menuContent.scrollTop = 0;
		}

		this.setState({
			menuOpen: !this.state.menuOpen
		});
	}

	inputChangeHandler(event) {
		var stateObj = {};

		stateObj[event.target.name] = event.target.value;

		this.setState(stateObj);
	}

	searchKeyDownHandler(event) {
		if (event.keyCode === 13) { // enter
			this.searchButtonClickHandler();
		}
	}

	searchButtonClickHandler() {
		if (this.state.searchString !== '') {
			this.refs.router.history.push('/leit/'+this.state.searchString);
		}
	}

	render() {
		return (
			<BrowserRouter ref="router">
				<React.Fragment>
					<div className={'app-container'+(this.state.menuOpen ? ' menu-open' : '')}>

						<header id="mainHeader" className="main-header">
							<div className="container">

								<div className="d-flex">

									 <button className="app-menu-button menu-button" ref="menuButton" onClick={this.menuButtonClickHandler}>
										<span className="hamburger-icon">
											<span className="icon-middle"></span>
											<span className="icon-before-after"></span>
										</span>
									 </button>

									 <a className="navbar-brand" href="/" rel="home">málið.is</a>

									<div className="input-group">

										<label htmlFor="search" className="screen-reader-text">{window.l('leita')}</label>

										<AutocompleteInput ref="searchInput"
											inputClassName="form-control"
											searchUrl={config.apiRoot+'flettulisti/$s'}
											onChange={this.inputChangeHandler}
											inputName="searchString"
											value={this.state.searchString}
											type="text"
											valueField="fletta"
											headerText="Hægt er að nota * og _ sem algildistákn."
											onFocus={this.inputFocusHandler}

											onEnter={this.searchButtonClickHandler}
											onItemSelect={(event) => {
												this.setState({
													searchString: event.fletta
												}, () => {
													this.searchButtonClickHandler()
												});
											}}
											placeholder={window.l('leita')}
											minChars={3}
											selectedItemClass="active"
											disableAutoFill={false}
											listLabelFormatFunc={(item) => <React.Fragment>
												<span className="link">{item.fletta}</span><br/>
												<small>{item.sofn}</small>
											</React.Fragment>}
										/>
										{/*
										<input type="search"
											className="form-control"
											ref="searchInput"
											name="searchString"
											id="search"
											placeholder={window.l('leita')}
											value={this.state.searchString}
											autoFocus=""
											onFocus={this.inputFocusHandler}
											onChange={this.inputChangeHandler}
											onKeyDown={this.searchKeyDownHandler}
										/>
										*/}
										<span className="input-group-btn">
											<button className="btn btn-default search-button" onClick={this.searchButtonClickHandler}>{/*<em className="fa fa-search" aria-hidden="true"></em>*/}</button>
										</span>
									</div>

									<a className="sam-logo" href="http://www.arnastofnun.is">
										<img className="single" alt="Árnastofnun" src="/img/sam-logo-single.png" />
										<img className="full" alt="Árnastofnun" src="/img/sam-logo.png" />
									</a>

								</div>

							</div>
						</header>

						<Route exact strict path="/"
							render={function(routeProps) {
								if (routeProps.location.search && routeProps.location.search.substr(0, '?search='.length) === '?search=') {
									setTimeout(() => {
										if (this.refs.router) {
											this.refs.router.history.push('/leit/'+routeProps.location.search.replace('?search=', ''));
										}
									}, 100);
								}
								return <SearchResultsList frontPage={true} />
						}.bind(this)} />

						<Route strict path="/leit/:searchString"
							render={function(routeProps) {
								return <SearchResultsList onSearch={function(event) {
									if (event.searchString !== this.state.searchString) {
										this.setState({
											searchString: event.searchString
										})
									}
								}.bind(this)} {...routeProps} />
						}.bind(this)} />

						<Route path="/leit/:searchString/link"
							render={(routeProps) => (
							<LinkView {...routeProps} />
						)} />
					</div>

					<div id="appMenu" className={'main-menu'+(this.state.menuOpen ? ' open' : '')}>
						<button className="app-menu-button close-button" onClick={
							function() {
								this.setState({
									menuOpen: false
								});
							}.bind(this)}>
							 <span className="hamburger-icon black open">
								<span className="icon-middle"></span>
								<span className="icon-before-after"></span>
							</span>
						</button>

						<AppMenu ref="appMenu" menuOpen={this.state.menuOpen} />

					</div>

					<GoogleAnalytics />
					<MatomoVeftalning />
				</React.Fragment>
			</BrowserRouter>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js